const routes = [
    {
        name: "purchase",
        path: "/purchase",
        component: () => import("@/views/erp/purchase.vue"),
        meta: { h5Header: true, h5TitleKey: "purchase.title" },
    },
    {
        name: "purchase_single",
        path: "/purchase/:id",
        component: () => import("../views/erp/purchase_single.vue"),
        meta: { h5Header: true, h5TitleKey: "purchase.detailTitle" },
    },
];

export default routes;
